const words = ["Realtor", "Creator", "Model", "Actor", "Entrepreneur", "UGC Talent"];

export const Marquee = () => {
  // Duplicate list for seamless infinite loop
  const items = [...words, ...words, ...words, ...words];
  return (
    <section
      aria-label="Editorial ribbon"
      data-testid="editorial-marquee"
      className="border-y border-charcoal/10 bg-cream py-6 overflow-hidden"
    >
      <div className="marquee-track items-center">
        {items.map((w, i) => (
          <div key={i} className="flex items-center gap-10 pr-10 whitespace-nowrap">
            <span className="font-serif-heading italic text-3xl md:text-5xl text-charcoal/90">{w}</span>
            <span className="text-bronze text-2xl">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
